// extracted by mini-css-extract-plugin
export default {"error":"ErrorItem_error__I7Tc3","property":"ErrorItem_property__anucp"};